import React from 'react'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'

function StatusBadge() {
  const selectState = createSelector(state => state.Campaign, state => state.currentVersion);
  const currentVersion = useSelector(selectState);

  function checkStatusAndRenderBadge() {
    if (currentVersion.published === 0) {
      return (
        <span className='badge bg-warning-subtle text-primary badge-border'>Draft</span>
      )
    } else if (currentVersion.published === 2) {
      return (
        <span className='badge bg-success-subtle text-primary badge-border'>Published</span>
      )
    } else if (currentVersion.published === 1) {
      return (
        <span className='badge bg-info-subtle text-info badge-border'>Partially Published</span>
      )
    }
  }

  return (
    <React.Fragment>
      {currentVersion ? checkStatusAndRenderBadge() : null}
    </React.Fragment>
  )
}

export default StatusBadge
